import BaseTreeView from '../BaseTreeView/BaseTreeView';

export default BaseTreeView.extend({
}, "ControlPanel");
